export default __webpack_public_path__ + "static/media/success.04b74d0c.jpg";